import React from "react";
import "./index.scss";

type Props = {
    style?: React.CSSProperties;
    children?: React.ReactNode;
    className?: string;
};
const Container: React.FC<Props> = ({ style , children , className }) => {
	return (
		<div style={style} className={`container ${className}`}>
			{children}
		</div>
	)
};

export default Container;
